import DeleteUserRequestModelBase from '../_generated/modelBases/delete-user-request-model-base';

export default class DeleteUserRequestModel extends DeleteUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
